import adminApiClient from './apiClient.js';

export const ferramentasApi = {
  list: async (params = {}) => {
    const { data } = await adminApiClient.get('/ferramentas/', { params });
    return data;
  },
  create: async (payload) => {
    const { data } = await adminApiClient.post('/ferramentas/', payload);
    return data;
  },
  update: async (id, payload) => {
    const { data } = await adminApiClient.put(`/ferramentas/${id}`, payload);
    return data;
  },
  remove: async (id) => {
    await adminApiClient.delete(`/ferramentas/${id}`);
  },
  getCategorias: async (id) => {
    const { data } = await adminApiClient.get(`/ferramentas/${id}/categorias`);
    return data;
  },
  setCategorias: async (id, categoriaIds) => {
    const { data } = await adminApiClient.put(`/ferramentas/${id}/categorias`, { categoria_ids: categoriaIds });
    return data;
  },
  getSpaces: async (id) => {
    const { data } = await adminApiClient.get(`/ferramentas/${id}/spaces`);
    return data;
  },
  addSpace: async (id, spaceId) => {
    const { data } = await adminApiClient.post(`/ferramentas/${id}/spaces`, { space_id: spaceId });
    return data;
  },
  removeSpace: async (id, spaceId) => {
    await adminApiClient.delete(`/ferramentas/${id}/spaces/${spaceId}`);
  },
};

export default ferramentasApi;
